import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

const animatingBackgroundColor = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -300% 0;
  }
`;

const LoadingBarContainer = styled.div`
  display: inline-flex;
  width: 100%;
  max-width: ${props => props.maxWidth}px;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const LoadingBar = styled.div`
  width: 100%;
  height: ${props => props.height}px;
  background: rgb(231, 232, 233);
  background: -moz-linear-gradient(
    90deg,
    rgba(231, 232, 233, 1) 0%,
    rgba(245, 245, 246, 1) 50%,
    rgba(231, 232, 233, 1) 100%
  );
  background: -webkit-linear-gradient(
    90deg,
    rgba(231, 232, 233, 1) 0%,
    rgba(245, 245, 246, 1) 50%,
    rgba(231, 232, 233, 1) 100%
  );
  background: linear-gradient(
    90deg,
    rgba(231, 232, 233, 1) 0%,
    rgba(245, 245, 246, 1) 50%,
    rgba(231, 232, 233, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#e7e8e9",endColorstr="#e7e8e9",GradientType=1);
  border-radius: ${props => props.height / 2}px;
  background-size: 300% auto;
  background-position: 0 100%;
  animation: ${animatingBackgroundColor} 3s linear infinite;
`;

const LoadingBarWrapper = ({ loading, data, height = 10, maxWidth = 200 }) => {
  if (loading) {
    return (
      <LoadingBarContainer maxWidth={maxWidth}>
        <LoadingBar height={height} />
      </LoadingBarContainer>
    );
  } else {
    return <span>{data}</span>;
  }
};

LoadingBarWrapper.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  height: PropTypes.number,
  maxWidth: PropTypes.number,
};

export default LoadingBarWrapper;
